var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, PacemEventTarget, LogLevel } from './_default-imports';
import { TweenService } from '../../animations/tween-service';
import { AnimationEvent as PacemAnimationEvent, AnimationStartEvent, AnimationEndEvent } from '../../animations/events';
//namespace Pacem.Components {
let PacemTweenElement = class PacemTweenElement extends PacemEventTarget {
    constructor(_tweener = new TweenService()) {
        super();
        this._tweener = _tweener;
        this.duration = 1000;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'start') {
            if (val === true && this.disabled != true)
                this._animate();
        }
    }
    run() {
        return this._animate();
    }
    _animate() {
        var started = false;
        return this._tweener.run(this.from, this.to, this.duration, this.delay, this.easing, (time, value) => {
            started = started == false && this.dispatchEvent(new AnimationStartEvent());
            this.dispatchEvent(new PacemAnimationEvent({ time: time, value: this.value = value }));
            this.log(LogLevel.Info, 'value: ' + this.value);
            if (time == 1.0) {
                this.dispatchEvent(new AnimationEndEvent());
                // reset start property
                this.start = false; // <- will trigger the animation the next time that will be set to true
            }
        });
    }
};
__decorate([
    Watch({ emit: false })
], PacemTweenElement.prototype, "easing", void 0);
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.Number })
], PacemTweenElement.prototype, "from", void 0);
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.Number })
], PacemTweenElement.prototype, "to", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTweenElement.prototype, "duration", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTweenElement.prototype, "delay", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemTweenElement.prototype, "start", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemTweenElement.prototype, "value", void 0);
PacemTweenElement = __decorate([
    CustomElement({ tagName: P + '-tween' })
], PacemTweenElement);
export { PacemTweenElement };
//}
